/**
 * Analytics API: snapshots and insights. All endpoints are scoped to the
 * authenticated user via Bearer token. Used by the Analytics page and cards.
 */
import axios from 'axios';
import API_URL from '../config';

function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return { headers: { Authorization: token ? `Bearer ${token}` : '' } };
}

/** GET /api/analytics/snapshots?type=&from=&to= */
export async function getSnapshots(type = 'daily_compliance', from, to) {
  const res = await axios.get(`${API_URL}/api/analytics/snapshots`, {
    params: { type, from: from?.toISOString?.(), to: to?.toISOString?.() },
    ...getAuthHeaders(),
  });
  return res.data || [];
}

/** GET /api/analytics/snapshots/latest?type= */
export async function getLatestSnapshot(type = 'daily_compliance') {
  const res = await axios.get(`${API_URL}/api/analytics/snapshots/latest`, {
    params: { type },
    ...getAuthHeaders(),
  });
  return res.data;
}

/** GET /api/analytics/insights?activeOnly=true&limit=50 */
export async function getInsights(options = {}) {
  const { activeOnly = true, limit = 50 } = options;
  const res = await axios.get(`${API_URL}/api/analytics/insights`, {
    params: { activeOnly: activeOnly !== false, limit },
    ...getAuthHeaders(),
  });
  return res.data || [];
}

/** POST /api/analytics/insights/:id/acknowledge */
export async function acknowledgeInsight(id) {
  const res = await axios.post(
    `${API_URL}/api/analytics/insights/${id}/acknowledge`,
    {},
    getAuthHeaders(),
  );
  return res.data;
}

/** GET /api/compliance/timeline — upcoming deadlines (medical, insurance, vehicle reg/inspection, IFTA, MCS-150, UCR, clearinghouse). */
export async function getComplianceDeadlines(rangeDays = 90) {
  const res = await axios.get(`${API_URL}/api/compliance/timeline`, {
    params: { range: rangeDays },
    ...getAuthHeaders(),
  });
  return res.data;
}

/** GET /api/analytics/timeline — unified timeline (events + insights + snapshot deltas), paginated, newest first. */
export async function getTimeline(options = {}) {
  const { page = 1, limit = 20 } = options;
  const res = await axios.get(`${API_URL}/api/analytics/timeline`, {
    params: { page, limit },
    ...getAuthHeaders(),
  });
  return res.data;
}

/** GET /api/analytics/snapshots/compare — latest vs previous with deltas and contributors. window: 7, 30, or 90 days. */
export async function getSnapshotComparison(windowDays) {
  const params = windowDays === 7 || windowDays === 30 || windowDays === 90 ? { window: windowDays } : {};
  const res = await axios.get(`${API_URL}/api/analytics/snapshots/compare`, {
    params,
    ...getAuthHeaders(),
  });
  return res.data;
}
